import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Env } from '../env';
import { Observable } from 'rxjs/Observable';
import { Permission } from '../models/permission';
import { ContractListItemSource } from '../models/contractListItemSource';
import { ContractSource } from '../models/contractSource';
import { observableToBeFn } from 'rxjs/testing/TestScheduler';
import { PropertyListItem } from '../models/propertyListItem';
import { Property } from '../models/property';
import { DivisionPItem } from '../models/DivisionPItem';

@Injectable()
export class DivisionService {

    constructor(private http: HttpClient, private global: Env) { }

    getAllByProperty( property:string ):Observable<DivisionPItem[]>{
      
      const url = this.global.division+'?property='+property;
      console.log(url);
      return this.http.get(url).map((res: DivisionPItem[]) => {
        return res;
      });
    }
    getAll( page:number ):Observable<DivisionPItem[]>{
      const url = this.global.division;
      console.log(url);
      return this.http.get(url).map((res: DivisionPItem[]) => {
        return res;
      });
    }
    
    get(id):Observable<any[]> {
      const url = this.global.division+'/'+id;
      return this.http.get(url).map((res: any[]) => {
        return res;
      });
    }
    

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/division.service.ts